const { container } = require('@/container');

/**
 * Generate stock level modal message HTML
 *
 * @param cart {Cart}
 * @param cartItem {CartLine}
 * @param fromModal {boolean}
 *
 * return {string}  HTML string
 */
export function generateStockLevelMessage(cart, cartItem, fromModal = false) {
    const userService = container.userService;
    const langService = container.langService;
    const isEdit = cart.getCartProductQuantityForLine(cartItem)?.qtyBeforeAdjustment > 0;
    const showBranchInMessage = userService.company.settings.enableCrossBranchSelling;

    const availableMessageKey = showBranchInMessage
        ? 'ORDER_DETAILS.STOCK_LEVEL_MODAL_AVAILABLE_BRANCH'
        : 'ORDER_DETAILS.STOCK_LEVEL_MODAL_AVAILABLE';

    const requestMessageKey = `ORDER_DETAILS.STOCK_LEVEL_MODAL_REQUEST${isEdit ? '_EDIT' : ''}${showBranchInMessage ? '_BRANCH' : ''}`;

    const availableMessage = langService.getText(availableMessageKey, {
        availableQty: cart.getAvailableStockForLine(cartItem) ?? 0,
        branchName: cartItem.branch.name,
        itemName: cartItem.getName(),
    });

    const requestedQtyMessage = langService.getText(requestMessageKey, {
        requestedQty: (cart.getCartProductQuantityForLine(cartItem)?.requiredQuantity ?? 0) + (fromModal ? 1 : 0),
        branchName: cartItem.branch.name,
    });

    const additionalMessage = langService.getText('ORDER_DETAILS.STOCK_LEVEL_MODAL_ADDITIONAL_MESSAGE');

    return `<p class="text-center">${availableMessage}</p>`
        + `<p class="text-center">${requestedQtyMessage}</p>`
        + `<p class="text-center">${additionalMessage}</p>`;
}
